<template>
  <div class="card border-inside">
    <div class="card-content">
      <div v-if="$i18n.locale === 'th'" class="content th info-list">
        <p>
          <span class="has-text-weight-normal">Project Overview: </span
          >สถานะและภาพรวมของ Company (ผู้ประกอบการ) ทั้งหมดใน Batch (โครงการ)
        </p>
        <ul class="list-none">
          <li class="inactive">
            <span class="has-text-weight-normal">Inactive:</span>
            สถานะเริ่มต้นของ Company (ผู้ประกอบการ) เมื่อเข้าสู่ Batch (โครงการ)
            เป็นครั้งแรก หรือ นำ Company (ผู้ประกอบการ)
            เข้าสู่ระบบเพื่อจะทำการบ่มเพาะในขั้นต่อไป
          </li>
          <li class="inprocess">
            <span class="has-text-weight-normal">In process:</span>
            ดำเนินการบ่มเพาะ สามารถใช้ระบบทั้งหมดได้
          </li>
          <li class="achieved">
            <span class="has-text-weight-normal">Achieved:</span>
            ผ่านการบ่มเพาะเรียบร้อยแล้ว แต่ไม่เป็นไปตาม KPI
            (ดัชนีชี้วัดควาสำเร็จ) ของการบ่มเพาะ
          </li>
          <li class="succeed">
            <span class="has-text-weight-normal">Succeed:</span>
            ผ่านการบ่มเพาะเรียบร้อยแล้ว เป็นไปตาม KPI (ดัชนีชี้วัดควาสำเร็จ)
            ของการบ่มเพาะ
          </li>
          <li class="deactive">
            <span class="has-text-weight-normal">Deactive:</span> Company
            (ผู้ประกอบการ) ถูกยกเลิกการบ่มเพาะ หรือ
            ไม่มีการดำเนินโครงการกับหน่วยบ่มเพาะเป็นเวลานาน
          </li>
        </ul>
      </div>
      <div v-else class="content th info-list">
        <p>
          <span class="has-text-weight-normal">Project Overview: </span>Status
          and Overview of All Companies (Entrepreneur) in the Batch (Project)
        </p>
        <ul class="list-none">
          <li class="inactive">
            <span class="has-text-weight-normal">Inactive:</span> Initial status
            of a company (entrepreneur) when entering the batch (project) or
            when introducing the company (entrepreneur) into the system for
            future cultivation.
          </li>
          <li class="inprocess">
            <span class="has-text-weight-normal">In process:</span> Actively
            undergoing cultivation, utilizing all systems.
          </li>
          <li class="achieved">
            <span class="has-text-weight-normal">Achieved:</span> Successfully
            completed cultivation but did not meet the KPIs (Key Performance
            Indicators) for cultivation.
          </li>
          <li class="succeed">
            <span class="has-text-weight-normal">Succeed:</span> Successfully
            completed cultivation and met the KPIs (Key Performance Indicators)
            for cultivation.
          </li>
          <li class="deactive">
            <span class="has-text-weight-normal">Deactive:</span> The company
            (entrepreneur) has been discontinued from cultivation or has not
            been engaged with the cultivation unit for a long period of time.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
ul.list-none {
  line-height: 1.5em;
}
ul li::before {
  content: "";
  line-height: 1.5em;
  width: 0.5em;
  height: 0.5em;
  float: left;
  margin: 0.4em 0.4em 0;
  border-radius: 50%;
  margin-left: -1rem;
}
ul li.inactive::before {
  background-color: #c6c6c6;
}
ul li.inprocess::before {
  background-color: #23d160;
}
ul li.achieved::before {
  background-color: #209cee;
}
ul li.succeed::before {
  background-color: #23d160;
}
ul li.deactive::before {
  background-color: #b5b5b5;
}
</style>